import http from 'plugins/axios';

export default {
  //获取交易对
  getPairList(){
    return http.get({
      url:'/ta/admin/tenant/symbol/getSymbolList',data:{type:'CONTRACT'}
    })
  },
  //动态查寻限价委托列表
  getOrderList(data){
    return http.get({
      url:'/ta/admin/contract/order/entrusts',
      data
    })
  },
  //撤销订单
  cancleOrder(orderId){
    return http.post({
      url:`/ta/admin/order/planning/commission/${orderId}/planningCommissionCancel`
    })
  },
  //查询成交列表明细
  getOrderDetails(data){
    return http.get({
      url:'/api/thanos-admin/v1/admin/order/detail-list',
      data
    })
  },
  //一键撤销
  cancelAll(data){
    return http.post({
      url:'/ta/admin/order/planning/commission/planningCommissionCancelAll',
      data
    })
  }
  
  
};
